import React from 'react';
import { Flex, Row } from 'antd';
import { TagOutlined, UsergroupAddOutlined, CreditCardOutlined } from '@ant-design/icons';
import NavItem from '../../../components/nav-item';
import SwitchShop from '../../shop/switch-shop';
import CouponList from './list';

const iconStyle = {
    fontSize: 28,
}

export default () => {
  return (
    <div>
        <SwitchShop />
        <Row gap={20} style={{ margin: '10px 0 0 0' }}>
            <NavItem href="/promotion/coupon/create" text="创建优惠券">
                <CreditCardOutlined style={iconStyle} />
            </NavItem>
        </Row>
        <h2>优惠券模版列表</h2>
        <CouponList />
    </div>
  )
}